export default "__VITE_ASSET__DFRtHiu1__"